import { render } from "./ArticleSelect.vue?vue&type=template&id=104940fd&scoped=true"
import script from "./ArticleSelect.vue?vue&type=script&lang=js"
export * from "./ArticleSelect.vue?vue&type=script&lang=js"

import "./ArticleSelect.vue?vue&type=style&index=0&id=104940fd&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104940fd"]])

export default __exports__